export const projectList = [
  {
    para: " AI Assessment Tool",
    image: "/images/ai.png",
    tech: "AI platform for PDF-to-MCQ generation with authentication, payments, admin panel, and analytics dashboard using MERN stack.",
    githublink: "https://github.com/asgardev119/testforge-ai-frontend",
    // liveLink: "https://books-managment-sage.vercel.app/",
  },
  {
    para: " AI Assessment Tool",
    image: "/images/ai.png",
    tech: "AI platform for PDF-to-MCQ generation with authentication, payments, admin panel, and analytics dashboard using MERN stack.",
    githublink: "https://github.com/asgardev119/testforge-ai-frontend",
    // liveLink: "https://books-managment-sage.vercel.app/",
  },

  {
    para: " SparkSurge – Car Wash Booking App",
    image: "/images/cr.png",
    tech: `Built production backend for SparkSurge (live on Play Store) – city-wise car wash booking with provider management, vehicle
categories, slot booking, and order tracking APIs.`,
    // githublink: "https://github.com/asgardev119/testforge-ai-frontend",
    liveLink: "https://sparksurgecarwash.com/",
  },

  {
    para: "Book Management System ",
    image: "/images/book-mern.png",
    tech: "Developed full-stack web app with CRUD operations for books",
    githublink: "https://github.com/asgardev119/book-managment",
    liveLink: "https://books-managment-sage.vercel.app/",
  },
  {
    para: "food web",
    image: "/images/food.png",
    tech: "React Js",
    githublink: "https://github.com/asgardev119/food-web",
    liveLink: "https://github.com/asgardev119/food-web",
  },
  {
    para: "mandi market web",
    image: "/images/mandi.png",
    tech: "React Js, Material UI",
    githublink: "https://github.com/asgardev119/mandi",
    liveLink: "https://mandimarket-mu.vercel.app/",
  },

  {
    para: "Task Management App",
    image: "/images/task-manage-app.png",
    tech: "React Js, Material UI",
    githublink: "https://github.com/asgardev119/task-managment-system",
    liveLink: "https://task-managment-system-eta.vercel.app/",
  },

  {
    para: "note taking web",
    image: "/images/noteweb.png",
    tech: "React Js , Tailwind css",
    githublink: "https://github.com/asgardev119/notes-web",
    liveLink: "https://notes-web-nu.vercel.app/",
  },
  {
    para: "Recipe web",
    image: "/images/rec-app.png",
    tech: "HTML5 , CSS3 ,Javascript",
    githublink: "https://github.com/asgardev119/recipe-app",
    liveLink: "https://asgar-recipe-app.netlify.app/",
  },
  {
    para: "internwala web",
    image: "/images/intern.png",
    tech: "HTML CSS Javascript",
    githublink: "https://internwala.netlify.app/",
    liveLink: "https://internwala.netlify.app/",
  },
  {
    para: "Time Tools",
    image: "/images/timetool.png",
    tech: "Javascript",
    githublink: "https://github.com/asgardev119/timepool",
    liveLink: "https://timepool.netlify.app/",
  },
  {
    para: "chat-bot",
    image: "/images/chat-bot.png",
    tech: "Javascript, qwen Api",
    githublink: "https://github.com/asgardev119/Mybot",
    liveLink: "https://mybot-opal.vercel.app/",
  },
  {
    para: "hireworld job portal",
    image: "/images/jobport.png",
    tech: "Javascript",
    githublink: "https://github.com/asgardev119/internshipTask-JOB_01",
    liveLink: "https://hireworld.netlify.app/",
  },

  {
    para: "virtual-assistance",
    image: "/images/robo.png",
    tech: "Javascript , CSS ",
    githublink: "https://github.com/asgardev119/Virtual-Assistance",
    liveLink: "https://virtual-assistance-three.vercel.app/",
  },
  {
    para: "railway pnr tracker",
    image: "/images/pnr.png",
    tech: "Javascript , api",
    githublink: "https://github.com/asgardev119/checkpnr_railwaystatus",
    liveLink: "https://asgardev119.github.io/checkpnr_railwaystatus/",
  },

  // {
  //   para: "crud-Web",
  //   image: "/images/crud.png",
  //   tech: "ReactJs, Typescript , JavaScript",
  //   githublink: "https://github.com/asgardev119/CrudWeb",
  // },

  {
    para: "Weather Web",
    image: "/images/sc2.png",
    tech: "html css javascript",
    githublink: "https://github.com/asgaransari19/SIMBT_weather",
    liveLink: "https://weatherwebasgar.netlify.app/",
  },
  {
    para: "Todo Web",
    image: "/images/sc4.png",
    tech: " Reactjs , MaterialUI ",
    githublink: "https://github.com/asgaransari19/toodo-app",
    liveLink: "https://toodoappas.netlify.app/adduser",
  },
  {
    para: "coinBased Web (gaming Earning Coin)",
    image: "/images/sc5.png",
    tech: "Reactjs and MaterialUI ",
    githublink: "https://github.com/asgaransari19/CoinBasedApp",
    liveLink: "https://coinbased.netlify.app/overview",
  },
  {
    para: "Food's Restaurant",
    image: "/images/sc7.png",
    tech: " Reactjs, MaterialUI ",
    githublink: "https://github.com/asgaransari19/restaurentapp",
    liveLink: "https://restuarentappas.netlify.app/foodmenu",
  },
  {
    para: "Calculator",
    image: "/images/cal.png",
    tech: "html css javascript",
    githublink: "https://github.com/asgaransari19/SimpleCalculator",
    liveLink: "https://asgarfirstcalculator.netlify.app/",
  },
];
